export default __webpack_public_path__ + "static/media/WhatsApp Community_Dana.66e85dd8.png";